import { apiFetch } from '../api-client';

export interface LedgerAccount {
  code: string;
  name: string;
  type: string;
  defaultBalance: 'debit' | 'credit';
  debit: number;
  credit: number;
  balance: number;
}

export interface LedgerEntry {
  date: string;
  code: string;
  description: string;
  offsetAccount: string;
  debit: number;
  credit: number;
}

export interface AccountDetail {
  account: { code: string; name: string; type: string; defaultBalance: 'debit' | 'credit' } | null;
  summary: { openingBalance: number; psDebit: number; psCredit: number; closingBalance: number; count: number };
  entries: LedgerEntry[];
}

export const ledgerApi = {
  accounts: (query: { from?: string; to?: string } = {}) => apiFetch<{ items: LedgerAccount[] }>(`/api/ledger/accounts${queryString(query)}`),
  detail: (code: string, query: { from?: string; to?: string } = {}) => apiFetch<AccountDetail>(`/api/ledger/accounts/${encodeURIComponent(code)}${queryString(query)}`),
};

function queryString(query: { from?: string; to?: string }) {
  const params = new URLSearchParams();
  if (query.from) params.set('from', query.from);
  if (query.to) params.set('to', query.to);
  return params.size ? `?${params.toString()}` : '';
}
